module.exports = __webpack_public_path__ + "static/media/everyday_digital_free_delivery2025.00570c21.png";